import styled from '@emotion/styled';
import { Slider } from '@mui/material';

export const StyledSlider = styled(Slider)`
    :not(.Mui-disabled) {
        .MuiSlider-track {
            color: ${({ theme }) => theme.colors.secondary.main};
        }

        .MuiSlider-rail {
            color: ${({ theme }) => theme.colors.secondary.main};
        }
    }

    .MuiSlider-thumb {
        color: white;
        box-shadow: 0px 1px 5px 0px #00000033;

        :hover,
        :focus-within {
            box-shadow: 0px 0px 0px 8px ${({ theme }) => theme.colors.secondary.main}27;
        }
    }

    .MuiSlider-thumb.Mui-active {
        box-shadow: 0px 0px 0px 14px ${({ theme }) => theme.colors.secondary.main}27;
    }
`;
